import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { switchAccountType } from '@shared/auth/switchAccountType';
import { useAuth } from '@shared/auth/AuthContext';
import OnboardBrand from './OnboardBrand';

/**
 * Where a business account adds the brands it follows. Before the first brand it already
 * browses the market and price check (preview mode, access_features.open_to_pending);
 * adding a brand (no verification since 2026-10-28) unlocks «Моя аналитика» and jobs.
 */
export default function ConnectBrand() {
  const { t } = useTranslation('customer');
  const tr = (k: string, d: string) => t(k, { defaultValue: d }) as string;
  const { accessStatus } = useAuth();
  const [switching, setSwitching] = useState(false);

  const becomeCreator = async () => {
    setSwitching(true);
    try { await switchAccountType('creator'); }
    catch (e) { alert((e as Error)?.message ?? String(e)); setSwitching(false); }
  };

  return (
    <div style={{ maxWidth: 640, margin: '0 auto' }}>
      <h2 className="c-page-title" style={{ margin: '0 0 6px' }}>{tr('connect.title', 'Добавьте свой бренд')}</h2>
      <p style={{ color: 'var(--muted)', lineHeight: 1.5, margin: 0 }}>
        {tr('connect.why', 'Обзор рынка и проверка цен уже открыты. Добавьте Instagram своего бренда — сразу откроются «Моя аналитика» (упоминания, охваты, блогеры вашего бренда) и задания для блогеров. Подтверждать ничего не нужно.')}
      </p>

      <OnboardBrand />

      {/* Wrong type? Switch to the creator side — only before a brand is verified. */}
      {accessStatus !== 'active' && (
        <div style={{ marginTop: 18, textAlign: 'center', fontSize: 13, color: 'var(--muted)' }}>
          {tr('onboardPage.notBusiness', 'Вы блогер, а не бизнес?')}{' '}
          <button type="button" onClick={becomeCreator} disabled={switching}
            style={{ background: 'none', border: 0, padding: 0, color: 'var(--accent, #4a9eff)', cursor: switching ? 'wait' : 'pointer', fontFamily: 'inherit', fontSize: 13, textDecoration: 'underline' }}>
            {switching ? '…' : tr('onboardPage.switchToCreator', 'Перейти в кабинет блогера')}
          </button>
        </div>
      )}
    </div>
  );
}
